import styled from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/toyotaTheme";

export const Wrapper = styled.div`
    width: 100%;
    padding-inline: var(--spacing-3);

    @media screen and (min-width: ${breakpoints.md}) {
        padding-inline: 0;
    }

    @supports not (padding-inline: 0) {
        padding-left: var(--spacing-3);
        padding-right: var(--spacing-3);

        @media screen and (min-width: ${breakpoints.md}) {
            padding-left: 0;
            padding-right: 0;
        }
    }
`;
